export function classArray(...classes: string[]): string {
    return classes.filter(v => v).join(" ");
}

function joinPath(...path: string[]): string {
    return path.map(part => part.replace(/(^\/|\/$)/g, '')).join("/");
}